import { useNavigate } from 'react-router-dom';
import './css/Banner.css';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

export default function BannerSection() {
  const navigate = useNavigate();

  return (
    <div className="opening-hours">
      <div className="content">
        <h2 className="section-title">OPENING TIME HOURS</h2>

        <div className="general-hours">
  <p><strong>Monday:</strong> Closed</p>
  <p><strong>Tuesday - Thursday:</strong> 11:00 am - 9:30 pm</p>
  <p><strong>Friday:</strong> 11:00 am - 10:00 pm</p>
  <p><strong>Saturday:</strong> 11:30 am - 10:00 pm</p>
  <p><strong>Sunday:</strong> 11:30 am - 9:30 pm</p>
</div>

<div className="schedule">
  <div className="box">
    <h3>LUNCH SPECIALS</h3>
    <p><strong>Lunch Chef's Special:</strong> 12:00 pm - 4:00 pm</p>
    <p><strong>Lunch Special:</strong> 12:00 pm - 4:00 pm</p>
    <p><strong>Thai Lunch Special:</strong> 12:00 pm - 4:00 pm</p>
  </div>

  <div className="box">
    <h3>DINNER HOURS</h3>
    <p><strong>Tuesday - Thursday:</strong> 4:00 pm - 9:30 pm</p>
    <p><strong>Friday:</strong> 4:00 pm - 10:00 pm</p>
    <p><strong>Saturday:</strong> 4:00 pm - 10:00 pm</p>
    <p><strong>Sunday:</strong> 4:00 pm - 9:30 pm</p>
  </div>
</div>


        <p className="special-note">
          “On holidays, it's a special day. We will open, and with special offers, we will announce.”
        </p>
      </div>
    </div>
  );
}
